







import store from '@/store';
export default
  props:
    name:
      type: String
      default: ''
    vName:
      type: String
      default: ''
    value:
      type: String
      default: ''
    checked:
      type: Boolean
      default: false
    group:
      type: String
      default: null
    # コントロール配列
    index:
      type: Number
      default: null
    disabled:
      type: Boolean
      default: false
    center:
      type: Boolean
      default: false
    right:
      type: Boolean
      default: false
    choice:
      type: Boolean
      default: false
    type:
      type: String
      default: 'checkbox'
    normal:
      type: Boolean
      default: false
    numChange:
      type: Boolean
      default: false
    colorGreen:
      type: Boolean
      default: false
    fileDownload:
      type: Boolean
      default: false
    colorRed:
      type: Boolean
      default: false
    colorYellow:
      type: Boolean
      default: false
    file:
      type: Boolean
      default: false
    noStore:
      type: Boolean
      default: false

  data: () ->
    ctrlName: ''

  created: () ->
    if @vName
      @ctrlName = @vName
    else
      @ctrlName = @name

  mounted: () ->
    if @checked
      @_saveStore(@value)

  methods: {
    change: (e) ->
      if e.target.checked
        @_saveStore(e.target.value)
      @$emit('change', e.target.value)
      @$emit('checked', e.target.checked)
    _saveStore: (value) ->
      if @numChange
        store.dispatch('setPostParam', {label: @ctrlName, value: Number(value), index: @index, group: @group})
      else
        if !@noStore
          store.dispatch('setPostParam', {label: @ctrlName, value: value, index: @index, group: @group})
    click: (e) ->
      @$emit('click')
  }
